import { GET_ITEMS_COUNTING_REPORT } from '../../modules/constants';

export function getItemsCountingReport(payload) {
  console.log('🚀 ~ itemsCountingReportActions.js:4 ~ payload:', payload);
  return {
    type: GET_ITEMS_COUNTING_REPORT,
    payload,
  };
}
